import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../../utils/constants'; // Adjust the import based on your project structure
import { MenuItem, Select, Typography } from '@mui/material';

export default function WithdrawDialog({
    open,
    setOpen,
    wallet
}) {
    const [amount, setAmount] = useState('');
    const [btcAddress, setBtcAddress] = useState('');
    const [token, setToken] = useState('btc');


    const handleClose = () => {
        setOpen(false);
        setAmount('');
        setBtcAddress('');
    };

    const handleWithdraw = async () => {
        // In a real application, you would handle the withdrawal logic here
        console.log('Withdrawing:', amount, 'BTC to address:', btcAddress);
        // handleClose(); // Close the dialog after attempting withdrawal
        const toastId = toast.loading("Withdrawing BTC...");

        try {
            // Simulate withdrawal logic
            const withdrawalAmount = parseFloat(amount);
            if (isNaN(withdrawalAmount) || withdrawalAmount <= 0) {
                throw new Error('Invalid amount');
            }
            if (!btcAddress) {
                throw new Error('Invalid Bitcoin address');
            }
            if (withdrawalAmount < 0.00051) {
                throw new Error('Minimum withdrawal amount is 0.00051 BTC');
            }

            let walletData = wallet.serializeIdentity; // Assuming this exists and works
            let chossenWallet = {};
            if (walletData) {
                chossenWallet = {
                    walletData: walletData,
                    type: "BTC"
                };
            } else {
                chossenWallet = {
                    walletData: wallet.privateKey,
                    type: "ICP"
                };
            }

            // Construct payload
            const payload = {
                ...chossenWallet,
                tokenId: token,
                address: btcAddress,
                amount: withdrawalAmount * 1e11, // Send numeric amount
                // Slippage format based on API requirements
            };

            const response = await fetch(`${ API_BASE_URL }/withdraw`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                toast.update(toastId, { render: `withdraw failed for ${ wallet.name }: ${ data.error || 'Unknown error' }`, type: "error", isLoading: false, autoClose: 5000 });
            } else {
                toast.update(toastId, { render: `withdrew ${ withdrawalAmount } from ${ wallet.name }!`, type: "success", isLoading: false, autoClose: 5000 });
            }
            // Simulate successful withdrawal
            console.log(`Successfully withdrew ${ withdrawalAmount } BTC to ${ btcAddress }`);
        } catch (e) {
            console.log(e);
            toast.update(toastId, { render: `Withdraw failed for ${ wallet.name }: ${ e.message || 'Unknown error' }`, type: "error", isLoading: false, autoClose: 5000 });
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Withdraw to Bitcoin from {wallet.name}</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    Enter the amount of Bitcoin to withdraw and your Bitcoin wallet address.
                </DialogContentText>

                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={token}
                    onChange={(event) => setToken(event.target.value)}
                    label="token"
                    fullWidth
                    variant="outlined"
                    // disabled
                >
                    <MenuItem value={token}>{token}</MenuItem>
                </Select>
                <TextField
                    autoFocus
                    margin="dense"
                    id="amount"
                    label="Amount (BTC)"
                    type="number"
                    fullWidth
                    variant="outlined"
                    placeholder="Amount (BTC)"
                    value={amount}
                    onChange={(event) => setAmount(event.target.value)}
                />
                <Typography variant="caption" color="red" gutterBottom>
                    Note: The minimum withdrawal amount is .00051 BTC.
                </Typography>
                <TextField
                    margin="dense"
                    id="btcAddress"
                    label="Bitcoin Wallet Address"
                    type="text"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter your Bitcoin wallet address"
                    value={btcAddress}
                    onChange={(event) => setBtcAddress(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleWithdraw} disabled={!amount || !btcAddress}>Withdraw</Button>
            </DialogActions>
        </Dialog>
    );
}